import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { CvxButton, CvxSpinnerButton } from "../../modules/cvx-ui-module";

export interface OdsConfirmRolloverDialogProps {
    show: boolean;
    rolloverMonth: string | undefined;
    onComplete: (dialogResult: boolean) => Promise<any>;
}

const OdsConfirmRolloverDialog: React.FC<OdsConfirmRolloverDialogProps> = ({
    show,
    rolloverMonth,
    onComplete,
    ...props
}) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const onCancel = async (): Promise<any> => {
        if (onComplete) {
            await onComplete(false);
        }
    };

    const onSubmit = async (): Promise<any> => {
        if (onComplete) {
            setIsSaving(true);
            await onComplete(true);
            setIsSaving(false);
        }
    };

    useEffect(() => {
        setIsSaving(false);
    }, [show]);

    return (
        <Modal className="theme-blue" show={show} centered backdrop='static' scrollable={true} onHide={onCancel}>
            <Modal.Header>
                <Modal.Title>Rollover to '{rolloverMonth}'</Modal.Title>
            </Modal.Header>
            <Modal.Body>Rollover data to '{rolloverMonth}'?</Modal.Body>
            <Modal.Footer>
                <CvxButton theme='accent' onClick={onCancel}>Close</CvxButton>
                <CvxSpinnerButton theme='primary' showSpinner={isSaving} onClick={onSubmit}>Rollover</CvxSpinnerButton>
            </Modal.Footer>
        </Modal>
    );
};

export default OdsConfirmRolloverDialog;
